import { axiosTemplate } from '../../axiosTemplate';
export const movEmailGroup = {
    endpoints: {
        test: `https://toy7kv2h68.execute-api.us-east-1.amazonaws.com/test`,
        acceptance: `https://fne12bsi3d.execute-api.us-east-1.amazonaws.com/acceptance`,
        prod: `https://xesrspmi7e.execute-api.us-east-1.amazonaws.com/prod`,
    },
    http: {
        create: ({ data, stage, token, cancelToken }) => {
            return axiosTemplate(token, cancelToken).post(`${movEmailGroup.endpoints[stage]}/email-groups`, data);
        },
        remove: ({ emailGroupId, token, stage, cancelToken }) => {
            return axiosTemplate(token, cancelToken).delete(`${movEmailGroup.endpoints[stage]}/email-groups/${emailGroupId}`);
        },
        get: ({ stage, token, cancelToken }) => {
            return axiosTemplate(token, cancelToken).get(`${movEmailGroup.endpoints[stage]}/email-groups`);
        },
        update: ({ data, token, emailGroupId, stage, cancelToken }) => {
            return axiosTemplate(token, cancelToken).put(`${movEmailGroup.endpoints[stage]}/email-groups/${emailGroupId}`, data);
        },
    },
};
